module.exports = __webpack_public_path__ + "img/botella_black_4.67be1082.jpeg";